import { HEX_SIZE, SIZE } from "./constants.js";
import { InvalidHexFormatError, InvalidHexStringError } from "./errors.js";

const HEX_REGEX = /^[0-9a-fA-F]{40}$/;

/**
 * Parse hex string to Address (standard form)
 *
 * @param {string} hex - Hex string with 0x prefix
 * @returns {import('./AddressType.js').AddressType} Address bytes
 * @throws {InvalidHexFormatError} If invalid format or length
 * @throws {InvalidHexStringError} If hex contains invalid characters
 *
 * @example
 * ```typescript
 * const addr = Address.fromHex("0x742d35Cc6634C0532925a3b844Bc9e7595f251e3");
 * ```
 */
export function fromHex(hex) {
	if (!hex.startsWith("0x") || hex.length !== HEX_SIZE) {
		throw new InvalidHexFormatError("Invalid hex format for address", {
			value: hex,
		});
	}
	const hexPart = hex.slice(2);
	if (!HEX_REGEX.test(hexPart)) {
		throw new InvalidHexStringError("Invalid hex string", {
			value: hex,
		});
	}
	const bytes = new Uint8Array(SIZE);
	for (let i = 0; i < SIZE; i++) {
		bytes[i] = Number.parseInt(hexPart.slice(i * 2, i * 2 + 2), 16);
	}
	return /** @type {import('./AddressType.js').AddressType} */ (bytes);
}
